import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import BlockchainConsulting from "./pages/Blockchain Consulting";
import Corebanking from "./pages/Corebanking.jsx";
import About from "./pages/About.jsx";
import Decentralisedplandeveloper from "./pages/Decentralisedplandeveloper.jsx";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/blockchain-consulting"
            element={<BlockchainConsulting />}
          />
          <Route path="/decentralised-mlm-plan-developer" element={<Decentralisedplandeveloper/>} />
          <Route path="/core-banking" element={<Corebanking/>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
